import { createAction } from '@reduxjs/toolkit';

export const flagsActions = {
  flagsProvider: {
    flagsInitialised: createAction('[flags provider] flags initialised'),
  },
};
